import { z } from 'zod';

export const InboxAttachmentSchema = z.object({
  idDocument: z.number().int().nullable(),
  FileName: z.string().nullable(),
});

export const InboxMailListItemSchema = z.object({
  idProcessManager: z.number().int(),
  idLegalTransaction: z.number().int().nullable(),
  Subject: z.string(),
  Sent_at: z.string().nullable(),
  MailRead: z.boolean(),
  AttachmentCount: z.number().int(),
});

export const InboxReplySchema = z.object({
  Body: z.string(),
  SentAt: z.string(),
  From: z.string().optional(),
  Source: z.enum(['mandant', 'notariat']).optional(),
});

export const InboxMailSchema = z.object({
  idProcessManager: z.number().int(),
  idLegalTransaction: z.number().int().nullable(),
  idLegalClient: z.number().int(),
  Subject: z.string(),
  Body: z.string(),
  Sent_to: z.string().nullable(),
  Sent_at: z.string().nullable(),
  Attachments: z.array(InboxAttachmentSchema),
  MailRead: z.boolean(),
  MailReadAt: z.string().nullable(),
  Replies: z.array(InboxReplySchema).optional(),
});

export type IInboxReply = z.infer<typeof InboxReplySchema>;

export type IInboxAttachment = z.infer<typeof InboxAttachmentSchema>;
export type IInboxMailListItem = z.infer<typeof InboxMailListItemSchema>;
export type IInboxMail = z.infer<typeof InboxMailSchema>;
